<template>
  <div id="dashboard-level1" style="min-height:650px;">
    <v-container grid-list-xl fluid>
      <div class="headline">
        <v-icon>developer_board</v-icon>&nbsp;IDENTITAS        
      </div>
      <v-divider></v-divider>
      <dashboard-level1-biodata></dashboard-level1-biodata>
      <dashboard-level1-exercise-list></dashboard-level1-exercise-list>          
    </v-container>    
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { format } from "date-fns";

export default {
  components: {
    "dashboard-level1-exercise-list": () => import("../Level1/DashboardLevel1ExerciseList"),
    "dashboard-level1-biodata": () => import("../Level1/DashbaordLevel1Biodata")
  },
  data() {
    return {
    };
  },
  filters: {
    date: function(value) {
      return format(new Date(value), "DD-MM-YYYY");
    }
  },
  mounted() {    
  },
  methods: {      
  }
};
</script>